import { FilterGroupCard } from "@/components/campaign/basic/FilterGroupCard";
import { EmptyCustomFilter } from "@/components/filters/EmptyCustomFilter";
import {
  filterCategories,
  groupFiltersByFilterGroup,
} from "@/data/filters/config";
import { TypedFilterGroup } from "@/data/filters/filter-types";
import { newCampaignStateAtom } from "@/services/new-campaign.service";
import { buildFilterGroupFromLabelInfo } from "@/utils/filter-utils";
import { createFileRoute } from "@tanstack/react-router";
import { useAtomValue } from "jotai";
import isEmpty from "lodash-es/isEmpty";
import { useMemo } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/define/$category/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { category: slug } = Route.useParams();
  const category = filterCategories[slug as keyof typeof filterCategories];

  const { appConfiguration: configuration } = Route.useRouteContext();
  const { configurations } = useAtomValue(newCampaignStateAtom);

  const addedFilterGroups = useMemo(() => {
    const groupedFilters = groupFiltersByFilterGroup(
      configurations.find((c) => c.quality === 1 && c.enabled)?.query.filters ??
        [],
    );
    const groupIds = new Set<string>();
    for (const { filterGroup } of groupedFilters) {
      groupIds.add(filterGroup.id);
    }
    return groupIds;
  }, [configurations]);

  const filterGroup = useMemo(() => {
    if (!configuration) return [];
    return category.id === "custom"
      ? buildFilterGroupFromLabelInfo(configuration.labelFilters)
      : (Object.values(category.filters) as TypedFilterGroup[]).map((f) => ({
          isAdvancedFilter:
            "isAdvancedFilter" in category ? category.isAdvancedFilter : false,
          ...f,
        }));
  }, [configuration, category]);

  return (
    <div className="flex h-full flex-col gap-y-8">
      {category.id === "custom" && isEmpty(filterGroup) && (
        <EmptyCustomFilter />
      )}

      <ul className="grid grid-cols-2 gap-6 xl:grid-cols-3">
        {category.id !== "contacts" &&
          filterGroup.map((filterGroup, index) => {
            return (
              <FilterGroupCard
                key={index}
                filterGroup={filterGroup}
                isAdded={addedFilterGroups.has(filterGroup.id)}
                link={{
                  from: Route.fullPath,
                  to: "/campaigns/setup/define/$category/$filter",
                  params: { filter: filterGroup.id },
                }}
                isAdvancedFilter={filterGroup.isAdvancedFilter}
              />
            );
          })}
      </ul>
    </div>
  );
}
